import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import extend from 'lodash/extend';
import config from '../../config';
import NumberUtils from '../../utils/NumberUtils';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import { CircularProgress } from './CircularProgress';
import { DeleteModal } from './DeleteModal';
import BrowserUtils from '../../utils/BrowserUtils';

/**
 * @todo
 * The quality of this component may be able to be improved in future improvement
 * work. This will help increase the health of the codebase.
 */
class ReducePotList extends Component {
  constructor(props) {
    super(props);

    this.decrement = this.decrement.bind(this);
    this.decrementCountCal = this.decrementCountCal.bind(this);
    this.decrementTotal = this.decrementTotal.bind(this);
    this.differenceObj = this.differenceObj.bind(this);
    this.increment = this.increment.bind(this);
    this.incrementCountCal = this.incrementCountCal.bind(this);
    this.incrementTotal = this.incrementTotal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onPaste = this.onPaste.bind(this);
    this.smClose = this.smClose.bind(this);
    this.smShow = this.smShow.bind(this);
    this.validateNumber = this.validateNumber.bind(this);
    this.checkNumber = this.checkNumber.bind(this);

    this.state = {
      balanceValue: `£${props.pot.balance}`,
      showModal: false,
      getFull: props.getFull,
      diff: 0,
    };
  }

  componentDidMount() {
    this.props.onToggle(this.props.id, this.props.pot.balance, {});
  }

  decrement() {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const potBalanceValue = parseFloat(balanceValue);
    if (potBalanceValue > 0) {
      const temp = potBalanceValue;
      if (temp % 10 === 0) {
        this.decrementCountCal();
      } else {
        this.decrementTotal(temp % 10);
      }
    }
  }

  decrementCountCal() {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const potBalanceValue = parseFloat(balanceValue);
    if (potBalanceValue > 0 && potBalanceValue <= 450) {
      this.decrementTotal(10);
    } else if (potBalanceValue > 450 && potBalanceValue <= 900) {
      this.decrementTotal(50);
    } else if (potBalanceValue > 900 && potBalanceValue <= 10000) {
      this.decrementTotal(100);
    } else {
      this.decrementTotal(1000);
    }
  }

  decrementTotal(e) {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const value = parseFloat(balanceValue) - e;
    const potBalanceValue = parseFloat(balanceValue);
    this.setState(
      {
        balanceValue: `£${value}`,
        diff: this.props.pot.balance - (potBalanceValue - e),
      },
      () => {
        const balanceValue = Number(
          this.state.balanceValue.replace(/[^\d.]*/g, '')
        );
        this.props.onToggle(
          this.props.id,
          parseFloat(balanceValue),
          this.differenceObj()
        );
      }
    );
  }

  differenceObj() {
    let obj = {};
    if (this.state.diff === 0) {
      obj = {};
    } else if (this.state.diff < 0) {
      obj = {
        amount: {
          currency: this.props.content.savingPotCurrencyType,
          value: Math.abs(this.state.diff),
        },
        source_pot_id: this.props.content.SavingPotUnallocatedText,
        target_pot_id: this.props.pot.id,
      };
    } else {
      obj = {
        amount: {
          currency: this.props.content.savingPotCurrencyType,
          value: Math.abs(this.state.diff),
        },
        source_pot_id: this.props.pot.id,
        target_pot_id: this.props.content.SavingPotUnallocatedText,
      };
    }
    return obj;
  }

  increment() {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const potBalanceValue = parseFloat(balanceValue);
    if (potBalanceValue < this.props.pot.goalAmount) {
      const temp = potBalanceValue;
      if (temp % 10 === 0) {
        this.incrementCountCal();
      } else {
        this.incrementTotal(10 - (temp % 10));
      }
    }
  }

  incrementCountCal() {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const potBalanceValue = parseFloat(balanceValue);
    if (potBalanceValue >= 0 && potBalanceValue <= 500) {
      this.incrementTotal(10);
    } else if (potBalanceValue > 500 && potBalanceValue <= 1000) {
      this.incrementTotal(50);
    } else if (potBalanceValue > 1000 && potBalanceValue <= 10000) {
      this.incrementTotal(100);
    } else {
      this.incrementTotal(1000);
    }
  }

  incrementTotal(e) {
    const balanceValue = Number(
      this.state.balanceValue.replace(/[^\d.]*/g, '')
    );
    const value = parseFloat(balanceValue) + e;
    this.setState(
      {
        balanceValue: `£${value}`,
        diff: this.props.pot.balance - (parseFloat(balanceValue) + e),
      },
      () => {
        const balanceValue = Number(
          this.state.balanceValue.replace(/[^\d.]*/g, '')
        );
        this.props.onToggle(
          this.props.id,
          parseFloat(balanceValue),
          this.differenceObj()
        );
      }
    );
  }

  onChange(e) {
    const isValid = this.checkNumber(e.target.value);
    let etarget;
    const goalValue = this.props.pot.goalAmount;
    const potBalanceValue = parseFloat(this.props.pot.balance);
    if (isValid) {
      etarget = e.target.value.replace(/[^\d.]*/g, '');
      if (etarget === '') {
        this.setState({ balanceValue: '£', diff: potBalanceValue - 0 }, () => {
          this.props.onToggle(this.props.id, 0, this.differenceObj());
        });
      } else if (etarget === '.') {
        this.setState(
          { balanceValue: '£0.', diff: potBalanceValue - 0 },
          () => {
            this.props.onToggle(this.props.id, 0, this.differenceObj());
          }
        );
      } else if (etarget === '0.') {
        this.setState(
          { balanceValue: '£0.', diff: potBalanceValue - 0 },
          () => {
            this.props.onToggle(this.props.id, 0, this.differenceObj());
          }
        );
      } else if (etarget === '0.0') {
        this.setState(
          { balanceValue: '£0.0', diff: potBalanceValue - 0 },
          () => {
            this.props.onToggle(this.props.id, 0, this.differenceObj());
          }
        );
      } else if (etarget === '0.00') {
        this.setState(
          { balanceValue: '£0.00', diff: potBalanceValue - 0 },
          () => {
            this.props.onToggle(this.props.id, 0, this.differenceObj());
          }
        );
      } else if (Number(etarget) === 0) {
        this.setState({ balanceValue: '£0', diff: potBalanceValue - 0 }, () => {
          this.props.onToggle(this.props.id, 0, this.differenceObj());
        });
      } else {
        if (Number(etarget) >= Number(goalValue)) {
          this.setState(
            {
              balanceValue: `£${goalValue}`,
              diff: potBalanceValue - goalValue,
            },
            () => {
              this.props.onToggle(
                this.props.id,
                goalValue,
                this.differenceObj()
              );
            }
          );
        } else {
          this.setState(
            {
              balanceValue: `£${etarget}`,
              diff: potBalanceValue - parseFloat(Number(etarget)),
            },
            () => {
              this.props.onToggle(
                this.props.id,
                Number(etarget),
                this.differenceObj()
              );
            }
          );
        }
      }
    }
  }

  onDelete() {
    const full = extend({}, this.props.getFull);
    delete full.pots[this.props.getKey];
    this.setState({
      getFull: full,
    });
    this.setState({ balanceValue: '£' }, () => {
      const balanceValue = Number(
        this.state.balanceValue.replace(/[^\d.]*/g, '')
      );
      this.props.onToggle(this.props.id, balanceValue, {});
    });
    SavingPotsActionCreator.deletePotConnection(this.props.pot.id);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_saving_goal_adjust_delete_goal,
        event: 'click',
      }
    );
  }

  onPaste(e) {
    e.preventDefault();
  }

  smClose() {
    this.setState({ showModal: false });
  }

  smShow() {
    this.setState({ showModal: true });
  }

  validateNumber(num) {
    const regex = /^(0|[1-9]\d*)(\.\d+)?$/;
    return regex.test(num);
  }

  checkNumber(e) {
    const etarget = e.replace(/[^\d.]*/g, '');
    const len = etarget.length;
    const index = etarget.indexOf('.');
    const dots = etarget.split('.').length;
    const beforeDecimalLen = etarget.split('.')[0].length;
    const goalValue = this.props.pot.goalAmount.toString();
    const goalValueBeforeDecimalLen = goalValue.split('.')[0].length;
    let isValid = true;

    if (beforeDecimalLen > 6) {
      isValid = false;
    }
    if (dots > 2) {
      isValid = false;
    }
    if (index >= 0) {
      const CharAfterdot = len + 1 - index;
      if (CharAfterdot > 4) {
        isValid = false;
      }
    }
    if (beforeDecimalLen > goalValueBeforeDecimalLen) {
      isValid = false;
    }
    if (beforeDecimalLen === goalValueBeforeDecimalLen) {
      if (Number(goalValue) < Number(etarget)) {
        isValid = false;
      }
    }
    return isValid;
  }

  render() {
    const { content, pot } = this.props;
    const potBalance = Number(this.state.balanceValue.replace(/[^\d.]*/g, ''));
    const potGoal = pot.goalAmount;
    const potName = pot.name;
    let targetDate = moment(pot.goalWhen).format('MMMM YYYY');
    const message = (
      <div>
        <p>
          {content.savingPotRejigDeletMessage1}
          <br />
          <br />
          {content.savingPotRejigDeletMessage2}
        </p>
      </div>
    );

    return (
      <div className="pot-adjustment">
        {BrowserUtils.isMobileView() ? (
          <article className="row no-gutters saving_pot_item adjust-pot mobile">
            <div className="col-xs-4">
              <CircularProgress potBalance={potBalance} potGoal={potGoal} />
              <div className="numberAdjust adjust-buttons">
                <div className="btn-numberAdjust">
                  <button onClick={this.decrement} type="button">
                    <img
                      src="../images/b/icons/remove.svg"
                      height="15"
                      alt=""
                    />
                  </button>
                  <button onClick={this.increment} type="button">
                    <img src="../images/b/icons/add.svg" height="15" alt="" />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xs-8 adjust-details">
              <p>{potName}</p>
              <div className="pot-target-date">
                {content.savingpotTargetDate} {targetDate}
              </div>
              <div className="numberAdjust">
                <input
                  type="text"
                  value={this.state.balanceValue}
                  className="form-control"
                  id="potScheduleValue"
                  placeholder=""
                  onChange={this.onChange}
                  onPaste={this.onPaste}
                />
                <div>
                  <p className="pot-budget">
                    {'of '}
                    <strong>{NumberUtils.appendCurrency('{}', potGoal)}</strong>
                  </p>
                  <button
                    className="page-options opt-green delete-mobile"
                    onClick={this.smShow}
                  >
                    <span className="icon icon-delete" />
                    {content.savingPotDeletePotButton}
                  </button>
                </div>
              </div>
            </div>
            {this.state.showModal && (
              <DeleteModal
                content={content}
                onHide={this.smClose}
                onDelete={this.onDelete}
                message={message}
              />
            )}
          </article>
        ) : (
          <article className="row no-gutters saving_pot_item adjust-pot">
            <div className="col-xs-8">
              <div className="row itemleft no-gutters">
                <div className="col-xs-4">
                  <CircularProgress potBalance={potBalance} potGoal={potGoal} />
                </div>
                <div className="col-xs-7">
                  <h4>{potName}</h4>
                  <div className="pot-target-date">
                    {content.savingpotTargetDate} {targetDate}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-4">
              <div className="numberAdjust">
                <input
                  type="text"
                  value={this.state.balanceValue}
                  className="form-control"
                  id="potScheduleValue"
                  placeholder=""
                  onChange={this.onChange}
                  onPaste={this.onPaste}
                />
                <div className="btn-numberAdjust">
                  <button onClick={this.decrement} type="button">
                    <img
                      src="../images/b/icons/remove.svg"
                      height="15"
                      alt=""
                    />
                  </button>
                  <button onClick={this.increment} type="button">
                    <img src="../images/b/icons/add.svg" height="15" alt="" />
                  </button>
                </div>
              </div>
              <div className="deletePotButton">
                <button
                  className="page-options opt-green"
                  onClick={this.smShow}
                >
                  {' '}
                  <span className="icon icon-delete" />
                  {content.savingPotDeletePotButton}{' '}
                </button>
              </div>
            </div>
            {this.state.showModal && (
              <DeleteModal
                content={content}
                onHide={this.smClose}
                onDelete={this.onDelete}
                message={message}
              />
            )}
          </article>
        )}
      </div>
    );
  }
}

ReducePotList.propTypes = {
  pot: PropTypes.object,
  id: PropTypes.number,
  getFull: PropTypes.object,
  onToggle: PropTypes.func,
  getKey: PropTypes.number,
  content: PropTypes.object,
};

export { ReducePotList };
